import { EntityStatusBadge } from '@frontend/components/badge';
import React from 'react';

import useDeviceStatusBadge from './device-status-badge-controller';

export interface DeviceStatusBadgeProps {
    status: string | null;
}

export const DeviceStatusBadge = (props: DeviceStatusBadgeProps) => {
    const viewProps = useDeviceStatusBadge(props);
    if (!props.status) return <></>;

    return (
        <EntityStatusBadge
            label={props.status}
            variant={viewProps.variant}
        />
    );
};
